import React, { useState } from 'react';
import { SceneProvider } from './contexts/SceneContext';
import Header from './components/Header';
import MainContent from './components/MainContent';
import Footer from './components/Footer';
import AnimationSystem from './components/AnimationSystem';

const App: React.FC = () => {
    const [animationState, setAnimationState] = useState('idle');
    const [consoleMessages, setConsoleMessages] = useState<string[]>([]);

    const addConsoleMessage = (msg: string) => {
        setConsoleMessages(prev => [...prev, msg]);
    };

    return (
        <SceneProvider>
            <div className="min-h-screen bg-gray-900 text-white font-inter flex flex-col items-center justify-center p-4">
                <Header />
                <MainContent animationState={animationState} setAnimationState={setAnimationState} consoleMessages={consoleMessages} />
                <Footer />
                <AnimationSystem animationState={animationState} setAnimationState={setAnimationState} addMessage={addConsoleMessage} />
            </div>
        </SceneProvider>
    );
};

export default App;

